import { css, CSSResult } from 'lit'
import { csFormControl } from 'elements/_shared/form.style.js'
import { csBorder, csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorAction, csColorBackground, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const cseStepperInput = {
  backgroundColor: css`var(--cse-stepper-input-background-color, ${csFormControl.backgroundColor})`,
  borderWidth: css`var(--cse-stepper-input-border-width, ${csFormControl.borderWidth})`,
  borderColor: css`var(--cse-stepper-input-border-color, ${csFormControl.borderColor})`,
  borderColorError: css`var(--cse-stepper-input-border-color-error, ${csFormControl.borderColorError})`,
  borderColorSuccess: css`var(--cse-stepper-input-border-color-success, ${csFormControl.borderColorSuccess})`,
  borderRadius: css`var(--cse-stepper-input-border-radius, ${csBorder.radiusFull})`,
  color: css`var(--cse-stepper-input-color, ${csFormControl.color})`,
  colorDisabled: css`var(--cse-stepper-input-color-disabled, ${csFormControl.colorDisabled})`,
  fontFamily: css`var(--cse-stepper-input-font-family, ${csFormControl.fontFamily})`,
  fontSize: css`var(--cse-stepper-input-font-size, ${csFormControl.fontSize})`,
  inputPadding: css`var(--cse-stepper-input-padding, ${csSpacing.spacing01})`,
  width: css`var(--cse-stepper-input-width, fit-content)`,
  gridTemplateColumn: css`var(--cse-stepper-input-grid-template-column, auto 4em auto)`,
}

export const cseStepperInputButton = {
  backgroundColor: css`var(--cse-stepper-input-button-background-color, ${csColorBackground.secondary})`,
  backgroundColorHover: css`var(--cse-stepper-input-button-background-color-hover, ${csColorAction.secondary})`,
  backgroundColorDisabled: css`var(--cse-stepper-input-button-background-color-disabled, ${csColorBackground.disabled})`,
  borderWidth: css`var(--cse-stepper-input-button-border-width, 0)`,
  borderColor: css`var(--cse-stepper-input-button-border-color, ${csFormControl.borderColor})`,
  borderColorHover: css`var(--cse-stepper-input-button-border-color-hover, ${csFormControl.borderColor})`,
  borderColorDisabled: css`var(--cse-stepper-input-button-border-color-disabled, ${csFormControl.borderColor})`,
  borderRadius: css`var(--cse-stepper-input-button-border-radius, ${csBorder.radiusFull})`,
  color: css`var(--cse-stepper-input-button-color, ${csColorAction.secondary})`,
  colorHover: css`var(--cse-stepper-input-button-color-hover, ${csColorText.white})`,
  colorDisabled: css`var(--cse-stepper-input-button-color-disabled, ${csColorText.muted})`,
  size: css`var(--cse-stepper-input-button-size, 42px)`,
}

export const style: CSSResult = css`
  .cse-stepper-input {
    background-color: ${cseStepperInput.backgroundColor};
    border-color: ${cseStepperInput.borderColor};
    border-style: solid;
    border-radius: ${cseStepperInput.borderRadius};
    border-width: ${cseStepperInput.borderWidth};
    display: grid;
    grid-template-areas: "decrease input increase";
    grid-template-columns: ${cseStepperInput.gridTemplateColumn};
    padding: ${cseStepperInput.inputPadding};
    width: ${cseStepperInput.width};
  }

  .cse-stepper-input.valid-error {
    border-color: ${cseStepperInput.borderColorError};
  }

  .cse-stepper-input.valid-success {
    border-color: ${cseStepperInput.borderColorSuccess};
  }

  .button {
    align-items: center;
    background-color: ${cseStepperInputButton.backgroundColor};
    border-color: ${cseStepperInputButton.borderColor};
    border-style: solid;
    border-radius: ${cseStepperInputButton.borderRadius};
    border-width: ${cseStepperInputButton.borderWidth};
    color: ${cseStepperInputButton.color};
    display: flex;
    height: ${cseStepperInputButton.size};
    justify-content: center;
    transition-duration: ${csTransition.duration};
    transition-property: border-color, color, background-color;
    transition-timing-function: ${csTransition.timingFunction};
    width: ${cseStepperInputButton.size};
  }

  .button:hover {
    background-color: ${cseStepperInputButton.backgroundColorHover};
    border-color: ${cseStepperInputButton.borderColorHover};
    color: ${cseStepperInputButton.colorHover};
  }

  .button[disabled] {
    background-color: ${cseStepperInputButton.backgroundColorDisabled};
    border-color: ${cseStepperInputButton.borderColorDisabled};
    color: ${cseStepperInputButton.colorDisabled};
  }

  .button:not([disabled]) {
    cursor: pointer;
  }

  .decrease-button {
    grid-area: "decrease";
  }

  .increase-button {
    grid-area: "increase";
  }

  input {
    color: ${cseStepperInput.color};
    font-family: ${cseStepperInput.fontFamily};
    font-size: ${cseStepperInput.fontSize};
    grid-area: "input";
    border: none;
    text-align: center;
    -moz-appearance: textfield;
    background-color: transparent;
  }

  input:focus {
    outline: none;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    margin: 0;
    -webkit-appearance: none;
  }

  input:disabled {
    color: ${cseStepperInput.colorDisabled};
  }
`
